import styled from '@emotion/styled'

// The SVG is a 1000x1000 canvas whose artwork only spans ~685x655 of it. The wrapper is the Figma size of the
// visible artwork (154x147); the canvas is scaled to 225px (154 / 0.685) and centered so the padding overflows.
// The extra 31px bottom margin plus the stack's 32px gap gives the 63px between artwork and title in Figma.
export const Illustration = styled.div`
  width: 154px;
  height: 147px;
  margin-bottom: 31px;
  position: relative;

  svg {
    display: block;
    width: 225px;
    height: 225px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
